var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-input"},[_c('b-input',{ref:"input",staticClass:"input-field",attrs:{"placeholder":_vm.placeholder,"custom-class":"no-border"},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}}),(_vm.errors)?_c('ValidationErrors',{attrs:{"errors":_vm.errors}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }